import { render, staticRenderFns } from "./GraficoGrid.vue?vue&type=template&id=8336b11a&"
import script from "./GraficoGrid.vue?vue&type=script&lang=ts&"
export * from "./GraficoGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports